import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/env';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  readonly isOffline = signal(!navigator.onLine);
  readonly isCheckingConnection = signal(false);

  constructor() {
    window.addEventListener('online', () => this.isOffline.set(false));
    window.addEventListener('offline', () => this.isOffline.set(true));
  }

  tryReconnect(): void {
    this.isCheckingConnection.set(true);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    fetch(environment.api_url, {
      method: 'HEAD',
      cache: 'no-cache',
      signal: controller.signal,
    })
      .then(() => this.isOffline.set(false))
      .catch(() => {
        if (navigator.onLine) this.isOffline.set(false);
      })
      .finally(() => {
        clearTimeout(timeout);
        this.isCheckingConnection.set(false);
      });
  }
}
